import React, { useState } from 'react';

const CredentialsModal = ({ credentials, onClose }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    // Create text with login information
    const text = `
Company: ${credentials.companyName}
Username: ${credentials.username}
Login Email: ${credentials.loginEmail || credentials.username}
Password: ${credentials.password}
    `.trim();

    navigator.clipboard.writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(err => {
        console.error('Failed to copy credentials: ', err);
      });
  };

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        <div style={styles.modalHeader}>
          <h2 style={styles.title}>Company Account Created</h2>
          <button onClick={onClose} style={styles.closeButton}>✕</button>
        </div>

        <div style={styles.modalBody}>
          <p style={styles.message}>
            A company account has been created successfully. Please securely share these credentials with the company.
          </p>

          <div style={styles.credentialsBox}>
            <div style={styles.credentialItem}>
              <span style={styles.label}>Company:</span>
              <span style={styles.value}>{credentials.companyName}</span>
            </div>
            <div style={styles.credentialItem}>
              <span style={styles.label}>Username:</span>
              <span style={styles.value}>{credentials.username}</span>
            </div>
            {credentials.loginEmail && (
              <div style={styles.credentialItem}>
                <span style={styles.label}>Login Email:</span>
                <span style={styles.value}>{credentials.loginEmail}</span>
              </div>
            )}
            <div style={styles.credentialItem}>
              <span style={styles.label}>Password:</span>
              <span style={styles.value}>{credentials.password}</span>
            </div>
          </div>

          <div style={styles.warning}>
            <span style={styles.warningIcon}>⚠️</span>
            <span>
              These credentials will only be shown once. Please save them securely.
            </span>
          </div>
        </div>

        <div style={styles.modalFooter}>
          <button
            onClick={copyToClipboard}
            style={copied ? styles.copiedButton : styles.copyButton}
          >
            {copied ? 'Copied!' : 'Copy Credentials'}
          </button>
          <button onClick={onClose} style={styles.closeModalButton}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: '8px',
    width: '90%',
    maxWidth: '500px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '90vh',
    overflow: 'hidden',
  },
  modalHeader: {
    padding: '1.5rem',
    borderBottom: '1px solid #eee',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'var(--primary-color)',
    color: 'white',
  },
  title: {
    margin: 0,
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    color: 'white',
    fontSize: '1.5rem',
    cursor: 'pointer',
    padding: '0.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
  modalBody: {
    padding: '1.5rem',
    overflowY: 'auto',
  },
  message: {
    marginBottom: '1.5rem',
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  credentialsBox: {
    backgroundColor: '#f8f9fa',
    border: '1px solid #e9ecef',
    borderRadius: '6px',
    padding: '1.25rem',
    marginBottom: '1.5rem',
  },
  credentialItem: {
    display: 'flex',
    marginBottom: '0.75rem',
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  label: {
    fontWeight: 'bold',
    minWidth: '100px',
    color: '#495057',
  },
  value: {
    fontFamily: 'monospace',
    backgroundColor: '#e9ecef',
    padding: '0.25rem 0.5rem',
    borderRadius: '4px',
    flexGrow: 1,
  },
  warning: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    backgroundColor: '#fff3cd',
    color: '#856404',
    padding: '0.75rem',
    borderRadius: '6px',
    fontSize: '0.9rem',
  },
  warningIcon: {
    fontSize: '1.25rem',
  },
  modalFooter: {
    padding: '1rem 1.5rem',
    borderTop: '1px solid #eee',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '1rem',
  },
  copyButton: {
    padding: '0.75rem 1.25rem',
    backgroundColor: 'var(--primary-color)',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  copiedButton: {
    padding: '0.75rem 1.25rem',
    backgroundColor: 'var(--success-color)',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  closeModalButton: {
    padding: '0.75rem 1.25rem',
    backgroundColor: '#6c757d',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
};

export default CredentialsModal;
